import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { MessageContext } from '../context/MessageContext';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null); // user: { id: user.id_manager, username: user.name, email: user.email } });
  const [loading, setLoading] = useState(true);
  const [serverNotAvailable, setServerNotAvailable] = useState(false);
  const { setMess } = useContext(MessageContext);

  // JWT login
  const login = async (login, password) => {
    try {
      if (!login || !password) {
        setMess({ color: "red", title: "Ошибка авторизации:", desc: "Введите логин и пароль " });
        throw new Error("Введите логин и пароль");
      }
      const response = await axios.post('/api/auth/login', { login, password });
      localStorage.setItem('accessToken', response.data.accessToken);
      setIsAuthenticated(true);
      setUser(response.data.user);
      return response.data;
    } catch (error) {
	  setIsAuthenticated(false);
      setUser(null);
      if (error.status === 503 || error.code === "ERR_BAD_RESPONSE") setServerNotAvailable(true);
      throw error.response?.data?.message || 'AuthContxt.jsx login Ошибка авторизации';
    }
  };

  // JWT logout
  const logout = async () => {
    try {
      await axios.post('/api/auth/logout');
      localStorage.removeItem('accessToken');
      setIsAuthenticated(false);
      setUser(null);
    } catch (error) {
      throw error.response?.data?.message || 'Ошибка при выходе';
    }
  };

  // JWT refresh
  const refresh = async () => {
    try {
      // console.log("Refreshing token...");
      const response = await axios.post('/api/auth/refresh', {}, {withCredentials: true});
      console.log("Новый access token:", response.data.accessToken);
      localStorage.setItem('accessToken', response.data.accessToken);
      setIsAuthenticated(true);
      setUser(response.data.user);
    } catch (error) {
      setIsAuthenticated(false);
      setUser(null);
      console.log("Ошибка при обновлении токена:", error.response?.data?.message || error.message);
    } finally {
      setLoading(false);
    }

  };

  // Проверка токена и автоматическое обновление
  const checkAuth = async () => {
    setLoading(true);
    //if (!user?.id) return;
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error('Нет токена');
      const response = await axios.get('/api/auth/me');
      setIsAuthenticated(true);
      setUser(response.data.user);
    } catch (error) {
      setIsAuthenticated(false);
      setUser(null);
      if (error.response?.data?.NoValidToken) {
        // setMess({ color: "red", title: "NoValidToken checkAuth:", desc: error.response?.data?.NoValidToken ?? error.message });
        await refresh();
      } else {
        // setMess({ color: "red", title: "Ошибка авторизации checkAuth:", desc: error.response?.data?.message || error.message });
        console.log(`\x1b[31mОшибка авторизации checkAuth: ${error.response?.data?.message || error.message}\x1b[0m`);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    // Добавляем interceptor для запросов
    console.log("Adding request interceptor");
    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('accessToken');
        console.log("Current token:", token);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    // Удаляем interceptor при размонтировании компонента
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, loading, login, serverNotAvailable, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};